var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.$store.state.toast.show)?_c('div',{staticClass:"abc-toast",class:[_vm.$store.state.toast.class],staticStyle:{"animation-duration":".3s"}},[_c('div',{staticClass:"toast-container"},[_c('span',[_vm._v(_vm._s(_vm.$store.state.toast.message))])])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }